/*
 * @Author: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @Date: 2024-07-26 10:12:50
 * @LastEditors: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @LastEditTime: 2024-07-28 22:37:55
 * @FilePath: \pc\coursearrange\src\api\fileSpace.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request'


//获取文件夹目录
export function getFileFolderAPI (params) {
    return request({
      url: `/folder/fileFolder/${params}`,
      method: 'GET',
    })
  }
  // export function getFileFolderAPI (params) {
  //   return request({
  //     url: `/folder/fileFolder`,
  //     method: 'GET',
  //   })
  // }

  //创建文件夹
  export function sbmCreateFolderAPI (data) {
    return request({
      url: `/folder/createFolder`,
      method: 'POST',
      data,
    })
  }

  //删除文件夹
  export function delFolderAPI (id) {
    return request({
      url: `/folder/delFolder/${id}`,
      method: 'DELETE',
    })
  }

//重命名文件夹
export function updateFolderAPI (data) {
    return request({
      url: `/folder/updateFolder`,
      method: 'PUT',
      data,
    })
  }

//列举文件夹列表
export function listFileAPI(data){
    return request({
        url:`/file/listFile`,
        method:'POST',
        data
    })
}

//删除文件
export function deleteFile(id){
    return request({
        url:`/file/deleteFile/${id}`,
        method:'DELETE',
    })
}

//查询文件是否重名
export function duplicateFileCheck(data){
    return request({
        url:'file/duplicateFileCheck',
        method:'POST',
        data
    })
}

//上传文件
export function createFileAPI(data){
    return request({
        url:'/file/createFile',
        method:'POST',
        data
    })
}


//重命名文件
export function updateFileAPI(data){
    return request({
        url:'/file/updateFile',
        method:'POST',
        data
    })
}

//列举文件列表
export function selectFileAPI(data){
    return request({
        url:'/file/selectFile',
        method:'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/fileSpace.js